import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  :global(.Calendar) {
    margin-left: auto;
    @include respond-to(md) {
      margin-left: 0;
      margin-top: 30px;
      width: 100%;
      :global(.Calendar__data-info) {
        width: 100%;
      }
    }
  }

  :global(.NewCRMTable__Body-Row):not(:last-child) {
    :global(.NewCRMTable__Cell--Tbody) {
      font-weight: 300;
    }
  }

  :global(.NewCRMTable__Body-Row):last-child {
    :global(.NewCRMTable__Cell--Tbody):nth-child(-n + 7) {
      border-left: 0;
      border-bottom: 0 !important;
    }
  }

  :global(.TotalCell) {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
  }
  :global(.Footer__Total) {
    width: 100%;
    text-align: end;
    font-weight: 500;
  }
  :global(.Managers__FooterCell) {
    font-weight: 600;
  }

  :global(.MoneyCellBoldFont) {
    :global(span) {
      font-weight: 500 !important;
    }
  }

  :global(.NewCRMTable__Cell--Tbody) {
    border-top: 1px solid #e9e9e9;
    border-left: 1px solid #e9e9e9;
  }

  :global(.LastCommentCell) {
    width: 100%;
    height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  :global(.NewCRMTable__Cell--Tbody) {
    &:hover {
      transition: none;
      background: #ebf7fd;
      border: 1px solid #78b8d6;
      border: none;
    }
  }

  :global(.NewCRMTable__wrapper) {
    @include respond-to(xl) {
      overflow-x: auto;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        width: 5px;
        height: 8px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #0aa1e2;
      }
    }
  }

  :global(.NewCRMTable) {
    @include respond-to(xl) {
      width: 1539px;
    }
  }

  :global(.PageContentPreloader) {
    padding: 20px 30px 0 11px;
    display: flex;
    flex-direction: column;
    gap: 26px;
  }
  :global(th) {
  }

  :global(.checkboxWrapper) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  :global(.CheckBox) {
    appearance: auto;
    opacity: 1;
    width: auto;
    border: none;
    display: flex;
    align-items: center;
    padding: 0;
    justify-content: center;
    /* max-width: 30px !important;
    min-width: 30px !important; */
  }
  :global(.ManagersTable) {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  :global(.ManagersTable__LastSeenHeaderWrapper) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  :global(.ManagersTable__LastSeenTitle) {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    color: #0f0f0f;
  }
  :global(.ManagersTable__LastSeenInfo) {
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #696969;
  }
  :global(.ManagersTable__CustomHeaderTitle) {
    font-weight: 700 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    color: #0f0f0f;
  }
  :global(.ManagersTable__CustomMoneyHeaderCellTitle) {
    :global(span) {
      font-weight: 700 !important;
      font-size: 12px !important;
      line-height: 14px !important;
      color: #0f0f0f;
    }
  }
  :global(.ManagersTable__CustomMoneyHeaderCellInfo) {
    font-weight: 300 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    color: #696969;
  }
  :global(.ManagersTable__CustomMoneyHeaderCellWrapper) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  :global(.NewCRMTable__Head-Row),
  :global(.NewCRMTable__Body-Row) {
    display: grid;
    grid-template-columns: 1fr 1.7fr 1.2fr 2fr 2fr 1.2fr 1fr 1fr 0.8fr;
  }

  :global(.NewCRMPagination__left) {
    margin-left: 9px;
  }
`;

const getDynamicStyles = () => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
